import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { DataSourceQuery } from "../../../_core/state/data-source/data-souce.query";
import { PublicDataSource } from "../../../../../../api/src/data-source/data-source.entity";

export interface DataExportPackageJsonDialog {
	title: string;
	description: string;
	dataSourceSlugs: string[];
}

@Component({
  selector: 'app-export-package-json-dialog',
  templateUrl: './export-package-json-dialog.component.html',
  styleUrl: './export-package-json-dialog.component.scss'
})
export class ExportPackageJsonDialogComponent {
	packageDataSources: PublicDataSource[] = [];

	constructor(
		public dialogRef: MatDialogRef<ExportPackageJsonDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public readonly data: DataExportPackageJsonDialog,
		private readonly datasourceQuery: DataSourceQuery
	) {}

	ngOnInit() {
		this.data.dataSourceSlugs.forEach(ds => {
			const datasourceMatch = this.datasourceQuery.getAll().find(dataSource => dataSource?.slug === ds);

			if (datasourceMatch) {
				this.packageDataSources.push(datasourceMatch);
			}
		})
	}

	submit() {
		/** for now we are sending an empty array,
		 * in the future we will send the selected data sources **/
		this.dialogRef.close([]);
	}
}
